export const BRANCH_DATA_REQUEST = "BRANCH_DATA_REQUEST"
export const SALE_DATA_REQUEST = "SALE_DATA_REQUEST"
export const UPDATE_PAGINATION_KEYVERIFICATION_LIST = "UPDATE_PAGINATION_KEYVERIFICATION_LIST"
export const UPDATE_KEYVERIFICATION_LIST = "UPDATE_KEYVERIFICATION_LIST"
export const UPDATE_KEYVERIFICATION_DETAIL_LIST = "UPDATE_KEYVERIFICATION_DETAIL_LIST"
export const UPDATE_KEYVERIFICATION_LOADING = "UPDATE_KEYVERIFICATION_LOADING"
export const UPDATE_KEYVERIFICATION_LIST_REQUEST = "UPDATE_KEYVERIFICATION_LIST_REQUEST"
export const UPDATE_PAGINATION_KEYVERIFICATION_DETAIL_LIST = "UPDATE_PAGINATION_KEYVERIFICATION_DETAIL_LIST"